import { useContext } from 'react';

import { RoleUserManagementModalContext } from './role-user-management-modal-provider';

function useRoleUserManagementModal() {
  const context = useContext(RoleUserManagementModalContext);

  if (!context) {
    throw new Error(
      'useRoleUserManagementModal must be used within a RoleUserManagementModalProvider',
    );
  }

  return context;
}

export { useRoleUserManagementModal };
